import _ from 'lodash';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * Returns the active schedule filter
 * @param {number} eventId Event ID
 * @returns [
 *     object,      // active filter
 *     boolean,     // true when a filter is active
 *     boolean,     // true when the active filter is the recommended one
 *     array        // filter categories
 *     object       // recommended filter
 * ]
 */
export function useScheduleFilter(eventId) {
    const selector = useCallback((state) => state.events[eventId]?.schedule, [eventId]),
        { filter, isRecommendedFilter, categories, recommendedFilter } = useSelector(selector);

    return useMemo(() => {
        const hasFilter = _(filter.categories).values().flatten().value().length;
        return [filter, hasFilter, isRecommendedFilter, categories || [], recommendedFilter];
    }, [filter, isRecommendedFilter, recommendedFilter]);
}
